import { HTTP } from '@/services/axios';

export async function getParameters({filterText,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/core/Parameter/getParameterList.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getParameter({parameterId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/core/Parameter/getParameterData.php?parameterId=${parameterId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });
    return result;
}


export async function unlockParameter({parameterId}){
    let result = {};

    var data = {'myRecordID':parameterId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Parameter/controlParameterUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getParameterOptions(){
    let result = [];
    
    await HTTP.get('/app/core/Parameter/getParameterOptions.php',{})
    .then(response => {
        result = response.data;  
    })
        .catch(function (error) {
        console.log(error);
    });

    return result;
}

export async function createParameter({data}){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/core/Parameter/controlParameterSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveParameter({data}){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/core/Parameter/controlParameterSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteParameter({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/core/Parameter/controlParameterDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}